export default "__VITE_ASSET__Co_vi8Ev__"